import { BlockT, ClampPoint, ModelBase, ModelUtils, Point, ViewEditor } from "pytha";
import { ConnectClamp } from "../clamp-point/ConnectClamp";

export class HvacTunnelConnectT extends BlockT {
    type = 'HvacTunnelConnectT';
    materialUuid: string;
    isJoint = true;

    setPosition(position: Point) {
        this.position = position;
    }

    setEntities(entities: ModelBase[]): void {
        this._entities = entities;
    }

    setNormal(normal: any) {
        this.normal = normal;
    }

    setAxisX(axisX: any) {
        this.axisX = axisX;
    }

    setMaterialUuid(materialUuid: string) {
        this.materialUuid = materialUuid;
    }

    clone() {
        const entity = new HvacTunnelConnectT().copy(this);
        entity.uuid = ModelUtils.generateUUID();
        return entity;
    }

    toJson() {
        let parentJson = super.toJson();
        let data = {
            ...parentJson,
            type: this.type,
            materialUuid: this.materialUuid
        }

        return data;
    }

    fromJson(json) {
        super.fromJson(json);
        return this;
    }

    attachClampPoints(editor: ViewEditor): ClampPoint[] {
        if (!!this._isLock) return [];
        let u2wChangedMatric4 = this.context.ucsContext.u2wChangedMatric4(this.axisX.clone(), this.normal.clone().cross(this.axisX), this.normal.clone(), this.position.clone());
        this.u2wMatrix = u2wChangedMatric4
        let res = []
        if (this.isJoint) {
            for (let i = 0; i < this.jointPointList.length; i++) {
                let midPoint = this.jointPointList[i].point.clone()
                midPoint.set(midPoint.x * this.scaleX, midPoint.y * this.scaleY, midPoint.z * this.scaleZ);
                midPoint.applyMatrix4(this.u2wMatrix);
                let midClamp = new ConnectClamp(editor, this, midPoint, this.jointPointList[i].key)
                res.push(midClamp)
            }
        } else {
            let clamp = new ConnectClamp(editor, this, this.position, 'position');
            res.push(clamp)
        }

        this.clampPoints = res;
        return res;
    }


}